import { content } from './family.content'
import {
  ActivationStatus,
  PostActivationStatus,
  SignUpStatus,
  Status,
  StatusColor,
} from '../types'

/*
 * Family group summary status mapping
 */

export const statusColorMapping: {
  [key in Status]: {
    status: string
    color: StatusColor
  }
} = {
  [SignUpStatus.SETUP]: {
    status: content.setup,
    color: StatusColor.GREEN,
  },
  [SignUpStatus.INVITATION_SENT]: {
    status: content.invitationSent,
    color: StatusColor.GREEN,
  },
  [SignUpStatus.COMPLETED]: {
    status: content.invitationAccepted,
    color: StatusColor.GREEN,
  },
  [ActivationStatus.ACTIVATION_REQUESTED]: {
    status: content.activationRequested,
    color: StatusColor.BLUE,
  },
  [ActivationStatus.AWAITING_ACTIVATION]: {
    status: content.awaitingActivation,
    color: StatusColor.BLUE,
  },
  [ActivationStatus.ACTIVATE_SIM]: {
    status: content.activateSim,
    color: StatusColor.GREY,
  },
  [ActivationStatus.ACTIVATION_FAILED]: {
    status: content.activationFailed,
    color: StatusColor.ORANGE,
  },
  [PostActivationStatus.ACTIVE]: {
    status: '', // We don't need to show this status label
    color: StatusColor.GREEN,
  },
  [PostActivationStatus.PAUSE_SCHEDULED]: {
    status: content.pauseScheduled,
    color: StatusColor.YELLOW,
  },
  [PostActivationStatus.PAUSED]: {
    status: content.paused,
    color: StatusColor.YELLOW,
  },
  [PostActivationStatus.PLAN_CHANGE_PENDING]: {
    status: content.planChangePending,
    color: StatusColor.BLUE,
  },
  [PostActivationStatus.EXPIRED]: {
    status: content.expired,
    color: StatusColor.YELLOW,
  },
  [PostActivationStatus.CLOSING]: {
    status: content.closingAccount,
    color: StatusColor.YELLOW,
  },
  [PostActivationStatus.CLOSED]: {
    status: content.closedAccount,
    color: StatusColor.YELLOW,
  },
  [PostActivationStatus.PLAN_CHANGE_PENDING_TO_SOLO]: {
    status: content.planChangePendingToSolo,
    color: StatusColor.BLUE, //TODO: Change to correct color if needed
  },
}

export const statusLabels: { [key: string]: string } = Object.fromEntries(
  Object.entries(statusColorMapping).map(([k, o]) => [k, o?.status || ''])
)

export const getStatusAndColor = (
  activationState: Status | null
): [string | null, StatusColor | null] =>
  activationState && statusColorMapping[activationState]
    ? [
        statusColorMapping[activationState].status,
        statusColorMapping[activationState].color,
      ]
    : [null, null]
